import * as React from "react"

const SvgHeading1 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M6 17a.97.97 0 0 1-.713-.288A.97.97 0 0 1 5 16V8a.97.97 0 0 1 .287-.712A.97.97 0 0 1 6 7a.97.97 0 0 1 .713.288A.97.97 0 0 1 7 8v3h4V8a.97.97 0 0 1 .287-.712A.97.97 0 0 1 12 7a.97.97 0 0 1 .713.288A.97.97 0 0 1 13 8v8a.97.97 0 0 1-.287.712A.97.97 0 0 1 12 17a.97.97 0 0 1-.713-.288A.97.97 0 0 1 11 16v-3H7v3a.97.97 0 0 1-.287.712A.97.97 0 0 1 6 17m12 0a.97.97 0 0 1-.712-.288A.97.97 0 0 1 17 16V9h-1a.97.97 0 0 1-.713-.287A.97.97 0 0 1 15 8a.97.97 0 0 1 .287-.712A.97.97 0 0 1 16 7h2q.424 0 .712.288A.97.97 0 0 1 19 8v8q0 .424-.288.712A.97.97 0 0 1 18 17" />
  </svg>
)
export default SvgHeading1
